import type {RemediationPageData} from "@ri2/app/server/routers/getRemediationPageData"
import {css} from "@styled-system/css"

/** Keeps the recommended card taller than its stretched siblings regardless of content. */
export const nonRecommendedInset = css({marginY: 31})

export interface RemediationProps {
  causeOnMessageId: number | "peek"
  caseModelId: string
  pageData: RemediationPageData
  openModal: () => void
  /** True while host estimate / server override for Replace is in flight. */
  isReplacePriceLoading?: boolean
}
